<bmcore-select-license-popup [colorSettingsMode]="colorSettingsMode"> </bmcore-select-license-popup>
